export default __webpack_public_path__ + "static/media/bookmark_blue.e068f088.svg";